module.exports = __webpack_public_path__ + "img/logo26.9930286d.jpg";